import PropTypes from 'prop-types';
import { reviewsListPropTypes } from '@Theme/natucare/modules/EkomiReviews/components/ReviewsList/ReviewsListPropTypes';
export const ekomiReviewsPropTypes = {
  heading: PropTypes.string,
  infoText: PropTypes.string,
  seal: PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  }),
  rating: PropTypes.shape({
    href: PropTypes.string,
    current: PropTypes.string,
    max: PropTypes.string,
    title: PropTypes.string
  }),
  numberOfRatings: PropTypes.shape({
    number: PropTypes.string,
    title: PropTypes.string
  }),
  reviews: reviewsListPropTypes.reviews,
  showMoreButtonText: reviewsListPropTypes.showMoreButtonText
};